import React, {useEffect} from 'react';
import {useInView} from 'react-intersection-observer';

type ElementInViewProps = {
  onInView: (options?: any) => Promise<any>;
  threshold?: number;
  height?: number;
};

function ElementInView(props: ElementInViewProps) {
  const {onInView, threshold = 0, height = 0} = props;
  const {ref, inView} = useInView({
    /* Optional options */
    threshold,
  });

  useEffect(() => {
    if (inView) {
      onInView?.();
    }
  }, [inView]);

  return <div style={{height}} ref={ref} />;
}

export default ElementInView;
